import apiClient from './index'

export default {
  getExamenesByRut(rut) {
    return apiClient.get(`/sangre/examenes/${rut}`)
  },
  uploadPDF(file) {
    const form = new FormData()
    form.append('file', file)
    return apiClient.post('/sangre/upload-pdf', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000
    })
  },
  importar(payload) {
    return apiClient.post('/sangre/importar', payload)
  }
}
